// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-- // Form // --*/
.mb-20 {
  margin-bottom: 20px;
}

.mb-40 {
  margin-bottom: 40px;
}

.myMeetingBlock forge-icon-button[aria-label="Close Dialog"] {
  cursor: pointer;
}

.myMeetingcontent {
  margin: 20px 10px 0px;
}
.myMeetingcontent h2 {
  color: #727272;
  font-size: 14px;
}
.myMeetingcontent .description-text {
  color: #727272;
}
.myMeetingcontent .sub-block span {
  color: #727272;
  font-size: 14px;
  font-weight: 400;
}

.meeting-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.myMeetingcontent-img img {
  max-width: 100%;
}

.forge-card-height forge-card {
  height: 270px;
  padding: 0;
}
.forge-card-height forge-card .card-body {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;
  color: rgb(0, 0, 0);
}

.attachment-img {
  border: 0;
  width: 100%;
  display: block;
}

.uploaded-img {
  display: flex;
  justify-content: center;
  align-items: center !important;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 5px;
}
.uploaded-img .attachment-icon-img {
  max-height: 120px;
  max-width: 80%;
  opacity: 0.7;
  margin: 0 auto;
}
.uploaded-img:hover .edit-mode {
  display: block;
}
.uploaded-img:hover .uploaded-img {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.3);
}

.edit-mode {
  position: absolute;
  top: 0;
  right: 5%;
}

.mr-10 {
  margin-right: 10px;
}

.schedule-height {
  padding-right: 1rem;
  overflow-y: auto;
}

.forge-icon {
  vertical-align: middle;
}

.description {
  max-height: 280px;
  overflow-y: auto;
}
.description .description-label {
  color: #727272;
  font-size: 14px;
}
.description .description-text {
  color: #727272;
  line-height: 1.25rem;
}

.dialog-title {
  padding: 10px 20px;
}
.dialog-title h2 {
  font-family: Roboto;
  font-size: 24px;
  letter-spacing: 0.3px;
  line-height: 28px;
  font-weight: 400;
}
.dialog-title .action-btn {
  text-align: right;
  padding: 10px 0 0;
}
.dialog-title .title-padding-30 {
  padding: 10px 20px;
}
.dialog-title .sub-block .forge-icon {
  vertical-align: middle;
}
.dialog-title .sub-block .label {
  font-size: 14px;
  word-break: break-word;
}

.pointer {
  cursor: pointer;
}

.card-body forge-icon-button {
  --forge-icon-button-size:36px;
  --forge-icon-button-shape:"squared" ;
}

.agenda-minutes-overview-button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.link-text {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}

.google-disclosure-text {
  font-size: 14px;
  line-height: 1rem;
  color: #3e3e3e;
  text-align: center;
}

@media screen and (min-width: 992px) and (max-width: 1280px) {
  .link-text {
    font-size: 1vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/meeting-manager/lib/popup/view-meeting/view-meeting.component.scss"],"names":[],"mappings":"AACA,mBAAA;AACA;EAAO,mBAAA;AACP;;AAAA;EAAO,mBAAA;AAIP;;AAFI;EACI,eAAA;AAKR;;AAFA;EACI,qBAAA;AAKJ;AAJI;EAAI,cAAA;EAAe,eAAA;AAQvB;AAPI;EAAmB,cAAA;AAUvB;AATI;EAAiB,cAAA;EAAe,eAAA;EAAgB,gBAAA;AAcpD;;AAZA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AAeJ;;AAbA;EACI,eAAA;AAgBJ;;AAbI;EACI,aAAA;EACA,UAAA;AAgBR;AAfO;EACK,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAiBZ;;AAZA;EAAgB,SAAA;EAAU,WAAA;EAAY,cAAA;AAkBtC;;AAjBA;EACI,aAAA;EACA,uBAAA;EAGA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EAAmB,kBAAA;AAqBvB;AApBI;EAAqB,iBAAA;EAAkB,cAAA;EAAe,YAAA;EAAa,cAAA;AA0BvE;AAxBQ;EAAW,cAAA;AA2BnB;AA1BQ;EAEE,+CAAA;AA6BV;;AA1BA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;AA6BJ;;AA3BA;EACI,kBAAA;AA8BJ;;AA5BA;EACI,mBAAA;EACA,gBAAA;AA+BJ;;AA5BA;EACI,sBAAA;AA+BJ;;AA7BA;EACI,iBAAA;EACA,gBAAA;AAgCJ;AA/BI;EAAqB,cAAA;EAAe,eAAA;AAmCxC;AAlCI;EAAoB,cAAA;EAAgB,oBAAA;AAsCxC;;AApCA;EACI,kBAAA;AAuCJ;AAtCI;EAAG,mBAAA;EAAmB,eAAA;EAAe,qBAAA;EAAoB,iBAAA;EAAiB,gBAAA;AA6C9E;AA5CI;EAAY,iBAAA;EAAiB,iBAAA;AAgDjC;AA/CI;EACI,kBAAA;AAiDR;AA9CQ;EAAY,sBAAA;AAiDpB;AAhDQ;EACI,eAAA;EACA,sBAAA;AAkDZ;;AA9CA;EACI,eAAA;AAiDJ;;AA/CA;EACI,6BAAA;EACA,oCAAA;AAkDJ;;AAhDA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAmDJ;;AAhDA;EACI,qBAAA;EACA,0BAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;AAmDJ;;AAhDA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAmDJ;;AAhDA;EACI;IACI,cAAA;EAmDN;AACF","sourcesContent":["\r\n/*-- // Form // --*/\r\n.mb-20{margin-bottom:20px}\r\n.mb-40{margin-bottom:40px}\r\n.myMeetingBlock{\r\n    forge-icon-button[aria-label=\"Close Dialog\"]{\r\n        cursor: pointer;\r\n    }\r\n}\r\n.myMeetingcontent{\r\n    margin: 20px 10px 0px;\r\n    h2 {color: #727272;font-size: 14px;}\r\n    .description-text {color: #727272;}\r\n    .sub-block span {color: #727272;font-size: 14px;font-weight: 400;}\r\n}\r\n.meeting-title{\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;              \r\n}\r\n.myMeetingcontent-img img {\r\n    max-width: 100%;\r\n}\r\n.forge-card-height  {\r\n    forge-card{\r\n        height: 270px;\r\n        padding: 0;\r\n       .card-body{\r\n            height:100%;\r\n            width:100%;\r\n            display:flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            flex-direction: column-reverse;\r\n            color: rgb(0, 0, 0);\r\n       }\r\n    }\r\n    \r\n}\r\n.attachment-img{border: 0;width: 100%;display: block;}\r\n.uploaded-img {\r\n    display: flex;\r\n    justify-content: center;\r\n    -webkit-box-align: end!important;\r\n    -ms-flex-align: end!important;\r\n    align-items: center!important;\r\n    height: 100%;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    position: relative;border-radius:5px;\r\n    .attachment-icon-img{max-height: 120px;max-width: 80%;opacity: 0.7;margin:0 auto;}\r\n    &:hover{\r\n        .edit-mode{display: block;}\r\n        .uploaded-img{-webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.30);\r\n          -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.30);\r\n          box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.30);}\r\n    }\r\n}\r\n.edit-mode {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 5%;\r\n }\r\n.mr-10 {\r\n    margin-right: 10px;\r\n}\r\n.schedule-height {\r\n    padding-right: 1rem;\r\n    overflow-y: auto;\r\n}\r\n\r\n.forge-icon{\r\n    vertical-align: middle;\r\n}\r\n.description {\r\n    max-height: 280px;\r\n    overflow-y: auto;\r\n    .description-label { color: #727272;font-size: 14px; }\r\n    .description-text { color: #727272; line-height: 1.25rem;}\r\n}\r\n.dialog-title {\r\n    padding: 10px 20px;\r\n    h2{font-family:Roboto;font-size:24px;letter-spacing:.3px;line-height:28px;font-weight:400}\r\n    .action-btn{text-align:right;padding:10px 0 0}\r\n    .title-padding-30 {\r\n        padding: 10px 20px;\r\n    }\r\n    .sub-block{\r\n        .forge-icon{vertical-align:middle;}\r\n        .label{\r\n            font-size: 14px;\r\n            word-break: break-word;\r\n        }\r\n    }\r\n}\r\n.pointer{\r\n    cursor:pointer;\r\n}\r\n.card-body forge-icon-button{\r\n    --forge-icon-button-size:36px;\r\n    --forge-icon-button-shape:\"squared\"\r\n}\r\n.agenda-minutes-overview-button-container{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.link-text {\r\n    white-space: pre-wrap;\r\n    white-space: -moz-pre-wrap;\r\n    white-space: -pre-wrap;\r\n    white-space: -o-pre-wrap;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.google-disclosure-text {\r\n    font-size: 14px;\r\n    line-height: 1rem;\r\n    color: #3e3e3e;\r\n    text-align: center;\r\n}\r\n\r\n@media screen and (min-width: 992px) and (max-width: 1280px){\r\n    .link-text {\r\n        font-size: 1vw;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
